/**
 * Contructor
 */
const config = {};

/**
 * Development configurations
 */
config.development = {
  API: {
    BASE: 'https://localhost:3002',
    FETCH_USER_INFO: '/user',
    LINK_PROVIDER: '/cognito/link-provider',
    SUBMIT_DEPOSIT_TX: '/swap/submit-deposit-tx',
    SUBMIT_REDEEM_TX: '/swap/submit-redeem-tx',
    GET_SWAP: '/swap/get-history',
    GET_REDEEM_CODE: '/swap/get-redeem-code',
  }
}

/**
 * Staging configurations
 */
config.staging = {
  API: {
    BASE: 'https://staging-api.kambria.io',
    FETCH_USER_INFO: '/user',
    LINK_PROVIDER: '/cognito/link-provider',
    SUBMIT_DEPOSIT_TX: '/swap/submit-deposit-tx',
    SUBMIT_REDEEM_TX: '/swap/submit-redeem-tx',
    GET_SWAP: '/swap/get-history',
    GET_REDEEM_CODE: '/swap/get-redeem-code',
  }
}

/**
 * Production configurations
 */
config.production = {
  API: {
    BASE: 'https://api.kambria.io',
    FETCH_USER_INFO: '/user',
    LINK_PROVIDER: '/cognito/link-provider',
    SUBMIT_DEPOSIT_TX: '/swap/submit-deposit-tx',
    SUBMIT_REDEEM_TX: '/swap/submit-redeem-tx',
    GET_SWAP: '/swap/get-history',
    GET_REDEEM_CODE: '/swap/get-redeem-code',
  }
}

/**
 * Module exports
 */
export default config;